import '../static/styles.module.css_.css';
import React__default, { memo, useState, useId, useMemo } from "react";
import clsx from "clsx";
import { a as FieldFooter } from "./FieldFooter.C6wlZlKr.mjs";
import { F as FieldLabel } from "./FieldLabel.D6ciKs0A.mjs";
const fieldbox = `_fieldbox_990f70b`;
const field = `_field_307b0e6`;
const floatingLabel = `_floatingLabel_de7ccf3`;
const hasSuffix = `_hasSuffix_0fa67be`;
const startSuffix = `_startSuffix_70f2f73`;
const centerSuffix = `_centerSuffix_57e22b3`;
const endSuffix = `_endSuffix_1923a0e`;
const styles = { fieldbox, field, floatingLabel, hasSuffix, startSuffix, centerSuffix, endSuffix };
const FIELD_BOX_THEME = ["white", "neutral"];
const FieldMemoized = memo(
  ({
    // eslint-disable-next-line react/prop-types
    children,
    ...props
  }) => React__default.cloneElement(children, props)
);
const FieldBox = ({
  className,
  id,
  asPlaceholder,
  label,
  labelId,
  labelVisible,
  required,
  requiredLabel,
  disabled,
  helperMessage,
  errorMessage,
  successMessage,
  children,
  suffix,
  suffixAlign = "center",
  onFocus,
  onBlur,
  value,
  theme,
  ...props
}) => {
  const labelProps = {
    htmlFor: id,
    label,
    labelId,
    labelVisible,
    required,
    requiredLabel
  };
  const [isFocus, setIsFocus] = useState(!!value);
  const helperId = useId();
  const hasHelper = useMemo(
    () => !!(helperMessage || errorMessage || successMessage),
    [helperMessage, errorMessage, successMessage]
  );
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      "data-field-box": true,
      "data-disabled": disabled,
      "data-invalid": !!errorMessage,
      "data-theme": theme,
      className: clsx(styles.fieldbox, className)
    },
    !asPlaceholder && /* @__PURE__ */ React__default.createElement(FieldLabel, { ...labelProps }),
    /* @__PURE__ */ React__default.createElement(
      "div",
      {
        "data-field-wrap": true,
        "data-focused": isFocus,
        className: clsx(styles.field, {
          [styles.floatingLabel]: asPlaceholder,
          [styles.hasSuffix]: !!suffix
        })
      },
      /* @__PURE__ */ React__default.createElement(
        FieldMemoized,
        {
          "data-field": true,
          "aria-describedby": hasHelper ? helperId : void 0,
          "aria-invalid": !!errorMessage,
          id,
          disabled,
          required,
          onFocus: (e) => {
            setIsFocus(true);
            if (onFocus)
              onFocus(e);
          },
          onBlur: (e) => {
            setIsFocus(!!value);
            if (onBlur)
              onBlur(e);
          },
          ...props
        },
        children
      ),
      suffix && React__default.cloneElement(suffix, {
        className: clsx(
          suffix.props.className,
          styles[`${suffixAlign}Suffix`]
        )
      }),
      asPlaceholder && /* @__PURE__ */ React__default.createElement(FieldLabel, { ...labelProps, asPlaceholder: true })
    ),
    /* @__PURE__ */ React__default.createElement(
      FieldFooter,
      {
        id: helperId,
        helperMessage,
        successMessage,
        errorMessage
      }
    )
  );
};
export {
  FIELD_BOX_THEME as F,
  FieldMemoized as a,
  FieldBox as b
};
//# sourceMappingURL=FieldBox.CBa86mdz.mjs.map
